<script>
import { Line } from 'vue-chartjs'
import ApiService from '@/services/common/api.service'
import moment from 'moment'

export default {
  extends: Line,
  props: {
    chartdata: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      dataGraph: {
        dropCompany: null,
        month: null,
        newCompany: null,
        year: null,
      },
      loaded: false,
      options: {
        legend: {
          position: 'bottom',
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                display: true,
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                display: true,
              },
            },
          ],
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    }
  },

  async mounted() {
    try {
      await ApiService.get('/auth/dashboard/graphic').then((response) => {
        this.dataGraph = response.data
      })
      this.loaded = true
    } catch (e) {
      console.error(e)
    }

    let months = this.dataGraph.map((element) =>
      moment()
        .month(element.month - 1, 'month')
        .startOf('month')
        .format('MMMM')
    )
    let newCompanies = this.dataGraph.map((element) => element.newCompany)
    let dropCompanies = this.dataGraph.map((element) => element.dropCompany)
    this.renderChart(
      {
        labels: months,
        datasets: [
          {
            label: 'New company',
            borderColor: '#4472C4',
            backgroundColor: 'transparent',
            data: newCompanies,
          },
          {
            label: 'Drop company',
            borderColor: '#ED7D31',
            backgroundColor: 'transparent',
            data: dropCompanies,
          },
        ],
      },
      this.options
    )
  },
}
</script>
